<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('support')" />
        <div class="card">
            <div class="card-body">
                <form method="post"
                      ref="form"
                      data-url="/admin/api/supports"
                      @submit.prevent="submitData">
                    <app-input
                        type="select"
                        v-model="formData.key"
                        :list="list"
                    />
                    <br/>
                    <div v-if="preloader" class="text-center">
                        <app-pre-loader />
                    </div>
                    <template v-else>
                        <app-input
                                v-if="formData.key !== 'site_contact_us_information'"
                                type="text-editor"
                                v-model="formData.content"
                                placeholder="Content"
                                :errorMessage="$errorMessage(errors, 'content')"
                        />
                        <template v-if="formData.key === 'site_contact_us_information'">
                            <app-form-group
                                :label="$t('email')"
                                type="email"
                                v-model="formData.email"
                                :placeholder="$placeholder('email')"
                                :errorMessage="$errorMessage(errors, 'email')"
                            />

                            <app-form-group
                                    :label="$t('phone_number_one')"
                                    v-model="formData.phone_number_one"
                                    :placeholder="$placeholder('phone_number_one')"
                                    :errorMessage="$errorMessage(errors, 'phone_number_one')"
                            />

                            <app-form-group
                                    :label="$t('phone_number_two')"
                                    v-model="formData.phone_number_two"
                                    :placeholder="$placeholder('phone_number_two')"
                                    :errorMessage="$errorMessage(errors, 'phone_number_two')"
                            />

                            <app-form-group
                                    type="textarea"
                                    :label="$t('address')"
                                    v-model="formData.address"
                                    :placeholder="$placeholder('address')"
                                    :errorMessage="$errorMessage(errors, 'address')"
                            />
                        </template>
                        <div class="form-group mt-3">
                            <submit-button
                                    :label="$t('save')"
                                    :loading="loading"
                                    @click="submitData"
                            />
                        </div>
                    </template>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import SubmitButton from "../../Helpers/Button/SubmitButton";
    import {axiosGet} from "../../../Helpers/AxiosHelper";

    export default {
        name: "Support",
        components: {SubmitButton},
        mixins: [FormHelperMixin],
        data() {
            return {
                formData: {
                    key: 'about_us',
                    content: ''
                }
            }
        },
        methods: {
            getContent() {
                this.preloader = true;
                axiosGet(`/admin/api/supports/${this.formData.key}`)
                    .then(response => {
                        if (this.formData.key === 'site_contact_us_information') {
                            this.formData = {key: 'site_contact_us_information', ...response.data}
                        }
                        this.formData.content = response.data;
                    })
                    .finally(() => this.preloader = false)
            },
            afterSuccess(response) {
                this.toastAndReload(response.data.message)
            },
        },
        computed: {
            list() {
                return [
                    {id: 'about_us', value: this.$t('about_us')},
                    {id: 'terms_&_condition', value: this.$t('terms_&_condition')},
                    {id: 'privacy_policy', value: this.$t('privacy_policy')},
                    {id: 'how_to_order', value: this.$t('how_to_order')},
                    {id: 'site_contact_us_information', value: this.$t('site_contact_us_information')},
                    {id: 'site_description', value: this.$t('site_description')},
                ]
            }
        },
        watch: {
            'formData.key': {
                handler: function () {
                    this.getContent();
                },
                immediate: true,
            },
        }
    }
</script>

<style scoped>

</style>